import { Component, OnInit } from '@angular/core';


@Component({
  selector: 'app-create-pages-dialog',
  templateUrl: './create-pages-dialog.component.html',
  styleUrls: ['./create-pages-dialog.component.scss']
})
export class CreatePagesDialogComponent implements OnInit {

  state = 0;

  // Message from the backend, shown as is. Optional, callers that have nothing
  // more specific than "it failed" keep calling onError() without arguments.
  errorDetail: string = null;

  // Set when pages were already created even though the upload failed, so the
  // user knows there are now pages without an image to clean up.
  orphanPages = false;

  constructor() {
  }

  ngOnInit() {
  }

  onError(errorDetail: string = null, orphanPages: boolean = false) {
    this.state = 1;
    this.errorDetail = errorDetail;
    this.orphanPages = orphanPages;
  }

}
